<template>
  <div>
  <v-card class="elevation-0">
    <v-card-title>
      <!-- รายชื่อคำร้องนักศึกษา <span v-if="academicYear" class="ml-2 primary--text">ภาคการศึกษาที่ {{ academicYear.semesterYear }}</span>
      <v-spacer></v-spacer> -->
      <v-text-field
        v-model="pagination.q"
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-select
        :items="requestTypeItems"
        v-model="pagination.requestType"
        label="ประเภทคำร้อง"
        item-text="name"
        item-value="id"
        box
        class="mt-3"
      ></v-select>
      <v-spacer></v-spacer>
      <v-select
        :items="statusItems"
        v-model="pagination.status"
        label="สถานะ"
        item-text="text"
        item-value="value"
        box
        class="mt-3"
      ></v-select>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="formDialog"
        persistent
        max-width="600px"
      >
        <template v-slot:activator="{ on }" v-if="hasAccess(allowedRoles)">
          <v-tooltip left>
            <v-btn color="teal" slot="activator" dark fab v-on="on">
              <v-icon>playlist_add</v-icon>
            </v-btn>
            <span>เพิ่มคำขอ</span>
          </v-tooltip>
        </template>
        
        <form-dialog :form="form" :valid="valid">
          <v-btn color="grey"  dark  @click="formDialog = false">
            ยกเลิก
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loading"
            :loading="loading"
            class="white--text"
            color="teal"
            @click="create"
          >
            บันทึก
          </v-btn>
        </form-dialog>
        
      </v-dialog>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
        <td class="text-xs-center">{{ props.item.letterNo }}</td>
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.year }}</td>
        <td class="text-xs-center">{{ props.item.faculty.nameTh }}</td>
        <td class="text-xs-center">{{ props.item.department.name }}</td>
        <td class="text-xs-center">{{ props.item.requestType.name }}</td>
        <td class="text-xs-center">{{ props.item.status | studentRequestStatus }}</td>
        <td>
          <v-layout>
            <template v-if="hasAccess(allowedRoles)">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editItem(props.item)"
                v-if="props.item.status !== 'COMPLETED'" 
              >
                edit
              </v-icon>
            </template>
            <v-icon
              color="green"
              class="mr-2"
              v-if="props.item.status === 'COMPLETED'" 
              @click="editItem(props.item)"
            >
              pageview
            </v-icon>
            <template v-if="hasAccess(allowedRoles)">
              <v-icon
                color="red"
                class="mr-2"
                @click="deleteItem(props.item)"
                v-if="props.item.status !== 'COMPLETED'" 
              >
                delete
              </v-icon>
            </template>
          </v-layout>
        </td>
      </template>
      <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert> -->
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
    </div>
  </v-card>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="80%"
  >
    <show-info :form="editedItem">
      <v-btn color="grey"  dark  @click="dialog = false">
        ปิด
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn :disabled="loading" :loading="loading" color="teal"  dark  @click="update" v-if="processStatus !== 'COMPLETED'">
        บันทึก
      </v-btn>
    </show-info>
  </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'
import FormDialog from './formBasic.vue'
import ShowInfo from './show.vue'

export default {
  props: ['academicYear', 'personItems'],
  mixins: [ hasAccessMixin ],
  components: {
    FormDialog,
    ShowInfo
  },
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      changed: true,
      dialog: false,
      formDialog: false,
      menu: false,
      loading: false,
      headers: [
        { text: '#', sortable: false, align: 'center', width: '10'},
        { text: 'เลขที่หนังสือ', align: 'left', sortable: false, value: 'letterNo'}, 
        { text: 'รหัสนักศึกษา', align: 'left', sortable: false, value: 'code'}, 
        { text: 'ชื่อ-นามสกุล', align: 'left', sortable: false, value: 'name'}, 
        { text: 'ชั้นปี', align: 'left', sortable: false, value: 'year'}, 
        { text: 'คณะ', align: 'left', sortable: false, value: 'faculty'}, 
        { text: 'สาขาวิชา', align: 'left', sortable: false, value: 'department'}, 
        { text: 'ประเภทคำร้อง', align: 'left', sortable: false, value: 'requestType'}, 
        { text: 'สถานะ', align: 'center', sortable: true, value: 'status'}, 
        { text: '', sortable: false} 
      ],
      statusItems: [
        { text: 'คำขอใหม่', value: 'NEW' },
        { text: 'รอความเห็นจากประธานรายวิชา/อ.ประจำวิชา', value: 'PENDING_INSTRUCTOR' },
        { text: 'รอความเห็นจากหัวหน้าสำนักงาน', value: 'PENDING_OFFICER' },
        { text: 'รอความเห็นจากคณบดี', value: 'PENDING_DEAN' },
        { text: 'เสร็จสิ้น', value: 'COMPLETED' }
      ],
      items: [],
      pagination: {
        q: '',
        sortBy: 'status',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        academicYear: null,
        status: '',
        requestType: ''
      },
      editedIndex: -1,
      editedItem: {
        status: '',
        receivedDate: null,
        recipient: null
      },
      defaultItem: {
        status: '',
        receivedDate: null,
        recipient: null
      },
      processStatus: null,
      form: {},
      valid: true
    }
  },
  mounted () {
    console.log('DataTable mounted...')
    this.reload()
  },
  computed: {
    ...mapGetters({
      requestTypes: 'requestType/requestTypeItems'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : `ดำเนินการ ${this.editedItem.requestorFullname}`
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    requestTypeItems () {
      let arr = [...this.requestTypes]
      console.log('arr', arr)
      arr.splice(0, 0, {id: '', name: 'ทั้งหมด'})
      return arr
    }
  },
  methods: {
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 200)
      this.reload()
    },
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
    editItem (item) {
      this.processStatus = item.status
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    update () {
      // console.log('update called...', this.editedItem)
      this.loading = true
      this.$store.dispatch('studentRequest/update', this.editedItem)
        .then((response) => {
          // console.log('onUpdate:', response )
          this.loading = false
          swal({
            title: 'สำเร็จ!',
            type: 'success'
          }).then(response => {
            this.close()
          })
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('เกิดข้อผิดพลาด!', error.message, 'error')
        })
    },
    create () {
      this.loading = true
      this.form.academicYear = this.academicYear
      const vm = this
      this.$store.dispatch("studentRequest/create", this.form)
        .then((response) => {
          swal({
              title: 'สำเร็จ!',
              type: 'success'
            }).then(response => {
              // TODO
              vm.formDialog = false
              vm.form = {}
            })
          this.reload ()
          this.loading = false
        }).catch((error)=>{
          console.error('create', error)
          this.loading = false
          let msg = error.response.status === 422 ? '*กรุณากรอกข้อมูลให้ครบถ้วน' : error.message
          swal('เกิดข้อผิดพลาด!', msg, 'error')
        })
    },
    deleteItem (item) {
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('studentRequest/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('เกิดข้อผิดพลาด!', error.message, 'error')
              })
          swal(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          )
        }
      })
    },
    reload () {
      this.loading = true
      console.log('reload by academicYear id: ', this.academicYear)
      if(this.academicYear) this.pagination.academicYear = this.academicYear.id
      this.$store.dispatch("studentRequest/loadItemsAsPage", this.pagination)
        .then((response) => {
          console.log('totalItems', response.data.totalItems)
          console.log('items', response.data.items)
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
          this.$emit('active', true)
        }).catch((error)=>{
          this.loading = false
          console.log('reload', error)
        })
    }
  },
  watch: {
    pagination: {
      handler (val) {
        this.reload()
        if(val.q) this.changed = false
      },
      deep: true
    },
    'academicYear' (val) {
      // console.log('watching academicYear id: ', val)
      if(val) this.form.academicYear = val
      this.changed = true
      setTimeout( ()=> this.reload (), 1000)
      
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/student/dataTable.vue